import { Head, useForm, Link } from '@inertiajs/react';
import AppLayout from '@/Layouts/AppLayout';
import Card, { CardBody } from '@/Components/Card';
import Button from '@/Components/Button';
import FormInput from '@/Components/FormInput';
import FormSelect from '@/Components/FormSelect';
import PageHeader from '@/Components/PageHeader';
import { UserIcon, EnvelopeIcon, LockClosedIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function Create({ roles }) {
    const { data, setData, post, processing, errors } = useForm({ name: '', email: '', password: '', password_confirmation: '', role_id: '' });
    const submit = (e) => { e.preventDefault(); post('/users'); };

    return (
        <AppLayout>
            <Head title="Create User" />
            <PageHeader title="Create User" subtitle="Add a new system user" actions={<Button href="/users" variant="outline" size="sm"><ArrowLeftIcon className="w-4 h-4" /> Back</Button>} />
            <Card>
                <CardBody>
                    <form onSubmit={submit} className="space-y-6 max-w-lg">
                        <FormInput label="Full Name" icon={UserIcon} value={data.name} onChange={e => setData('name', e.target.value)} error={errors.name} required />
                        <FormInput label="Email" type="email" icon={EnvelopeIcon} value={data.email} onChange={e => setData('email', e.target.value)} error={errors.email} required />
                        <FormSelect label="Role" value={data.role_id} onChange={e => setData('role_id', e.target.value)} error={errors.role_id} required>
                            <option value="">Select role...</option>
                            {roles?.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                        </FormSelect>
                        <FormInput label="Password" type="password" icon={LockClosedIcon} value={data.password} onChange={e => setData('password', e.target.value)} error={errors.password} required />
                        <FormInput label="Confirm Password" type="password" icon={LockClosedIcon} value={data.password_confirmation} onChange={e => setData('password_confirmation', e.target.value)} error={errors.password_confirmation} required />
                        <div className="flex gap-3 pt-4">
                            <Button type="submit" disabled={processing}>Create User</Button>
                            <Button href="/users" variant="outline">Cancel</Button>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </AppLayout>
    );
}
